import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=36074fb2&"
import script from "./CopyRight.vue?vue&type=script&lang=ts&"
export * from "./CopyRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports